export class User {
    id: number;
    userName: string;
    email: string;
    firstName: string;
    lastName: string;
    title: string;
    phoneNumber: string;
    ministry: string;
    ministryAcronym: string;
    division: string;
    branch: string;
    unit: string;
    address: string;
    city: string;
    province: string;
    postalCode: string;
    displayName: string;
    userRoleList: string;
    userRole: string;
};

export interface AuthToken {
    token_type?: string;
    expires_in?: number;
    access_token?: string;
    accessToken?: string;
    scope?: string;
    id_token?: string;
    idToken?: string;
    error_code?: number;
    error_messages?: string[];
}